(function($) {

  var $mutantNavMain = $('.c-mutant-nav');
  var $mutantNavAnchor = $(".c-mutant-nav__list li a");
  var $mutantNavSpan = $(".c-mutant-nav__label span");

  // Initialization of nav sticky
  $mutantNavMain.sticky(
    {
      topSpacing: 0
    }
  );

  // Event when nav becomes sticky
  $mutantNavMain.on('sticky-start', function() {
    $(this).addClass('c-mutant-nav--sticky');
  });

  // Event when nav is not sticky
  $mutantNavMain.on('sticky-end', function() {
    $(this).removeClass('c-mutant-nav--sticky');
  });

  // Toggle active class on links + Makes the scroll on page
  $mutantNavAnchor.click(function(e){
    $mutantNavAnchor.parent().removeClass('is-active');
    $(this).parent().addClass('is-active');
    
    // Change mutant nav span inner HTML
    $($mutantNavSpan).html($(this).html());

    var target = this.getAttribute("href");
    $("html, body").animate({
      scrollTop: ($(target).offset().top) - 56
    }, 800);

    $('.c-mutant-nav__checkbox').prop('checked', false); // closes dropdown list on mobile

  });

})(jQuery);